
































import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcTopAppBar extends Vue{
  @Prop({default:'タイトル'})
  title!:string

  isActive(name:string):boolean{
    return this.$route.name === name
  }
  clickTag(location:string){
    this.$router.push(location)
  }
}
